import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'
import BusinessAtAGlanceSkeleton from './business-at-a-glance/loading-skeleton'
import ManageBusinessSkeleton from './manage-business/loading-skeleton'
import QuickActionsSkeleton from './quick-actions/loading-skeleton'
import TodaysScheduleSkeleton from './todays-schedule/loading-skeleton'
import useDashboardStyles from './styles'

// Mirrors DashboardHeader's spacing and row so the greeting does not move.
const useStyles = makeStyles(theme => ({
  header: pageContentHorizontalGutters(theme, {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  }),
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  titleBlock: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}))

// Matches the default dashboard layout: glance card, schedule row, then the
// manage-business cards.
export default () => {
  const classes = useStyles()
  const dashboardClasses = useDashboardStyles()

  return (
    <>
      <Box className={classes.header} data-testid="dashboard-skeleton-header">
        <Box className={classes.headerRow}>
          <Box className={classes.titleBlock}>
            <Skeleton
              variant="text"
              width="min(100%, 320px)"
              height={48}
              style={{ marginBottom: 8 }}
            />
            <Skeleton variant="text" width="min(100%, 380px)" height={24} />
          </Box>
          <Box className={classes.actions}>
            <Skeleton
              variant="rect"
              width={168}
              height={40}
              style={{ borderRadius: 20 }}
            />
            <Skeleton variant="circle" width={40} height={40} />
          </Box>
        </Box>
      </Box>
      <Box className={dashboardClasses.mainContent}>
        <BusinessAtAGlanceSkeleton />
        <Box className={dashboardClasses.scheduleRow}>
          <TodaysScheduleSkeleton />
          <QuickActionsSkeleton />
        </Box>
        <ManageBusinessSkeleton />
      </Box>
    </>
  )
}
